const DEFAULT_FALLBACK_DELAY_MS = 1200;
const FALLBACK_LATE_THRESHOLD_MS = 2000;
const isIOSChrome = () => {
  const ua = navigator.userAgent;
  return /CriOS/i.test(ua) && /iPhone|iPad|iPod/i.test(ua);
};

const getFallbackDelayMs = () => {
  const raw = process.env.REACT_APP_NECKSOUND_FALLBACK_DELAY_MS;
  const parsed = raw ? Number(raw) : NaN;
  if (Number.isFinite(parsed) && parsed > 0) {
    return parsed;
  }
  return DEFAULT_FALLBACK_DELAY_MS;
};

export const openNeckSoundApp = (): boolean => {
  const appLink = process.env.REACT_APP_NECKSOUND_APP_LINK;
  const fallbackUrl = process.env.REACT_APP_NECKSOUND_TESTFLIGHT_URL;

  if (!appLink) {
    if (fallbackUrl) {
      window.location.assign(fallbackUrl);
      return true;
    }
    console.warn('NeckSound app link is missing. Set REACT_APP_NECKSOUND_APP_LINK.');
    return false;
  }

  const startedAt = Date.now();
  let fallbackTimer: number | undefined;
  let didBackground = false;
  const clearFallback = () => {
    if (fallbackTimer) {
      window.clearTimeout(fallbackTimer);
      fallbackTimer = undefined;
    }
  };

  const handleBackground = () => {
    didBackground = true;
    clearFallback();
  };

  // iOS Chrome may only emit "visible" on return, so treat any change as background.
  document.addEventListener('visibilitychange', handleBackground, { once: true });
  window.addEventListener('pagehide', handleBackground, { once: true });
  window.addEventListener('blur', handleBackground, { once: true });

  if (fallbackUrl && !isIOSChrome()) {
    fallbackTimer = window.setTimeout(() => {
      const elapsed = Date.now() - startedAt;
      const isLate = elapsed > getFallbackDelayMs() + FALLBACK_LATE_THRESHOLD_MS;
      if (!didBackground && !isLate && document.visibilityState === 'visible') {
        window.location.assign(fallbackUrl);
      }
    }, getFallbackDelayMs());
  }

  window.location.assign(appLink);
  return true;
};
